import axios from 'axios'
import PrefixPath from '../config/AppConfig'
import Constants from '../redux/Constants/Constants';
import { notification } from 'antd';
import { removeCookie,getCookie } from '../utils/AllCookies';



const service = axios.create({
  baseURL: PrefixPath.API_BASE_URL,
  timeout: 60000
})

const ENTRY_ROUTE = '/login'
const TOKEN_PAYLOAD_KEY = 'authorization'
// const PUBLIC_REQUEST_KEY = 'public-request'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = getCookie(Constants.AUTH_TOKEN)
  if (jwtToken && Object.keys(jwtToken).length > 0) {
    config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken?.jwtToken}`
  }

//   if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {

//   }

  return config
}, error => {
	notification.error({
		message: 'Something went wrong'
	})
  Promise.reject(error)
})

service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		message: ''
	}
	
	if (error.response.status === 400) {
		notificationParam.message = 'The submission could not be processed.'
		notificationParam.description = 'Please review your entries and try again.'

		//removeCookie(Constants.AUTH_TOKEN)
		//window.location.reload();
	}
if (error.response.status === 401 || error.response.status === 403) {
  if (!window.location.pathname.includes(ENTRY_ROUTE)) {
    notificationParam.message = 'Login failed.'
    notificationParam.description = 'Please log in again.'
    localStorage.clear();
    removeCookie(Constants.AUTH_TOKEN)
    notification.error(notificationParam)
    window.location.href = ENTRY_ROUTE
    return Promise.reject(error)
  }
}
	if (error.response.status === 404) {
		notificationParam.message = 'The requested item could not be found.'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'An unexpected error occurred. Please try again.'
	}
	
	if (error.response.status === 508) {
		notificationParam.message = 'Timed Out'
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service